import { render, staticRenderFns } from "./commentManage.vue?vue&type=template&id=2e13b3c8&scoped=true"
import script from "./commentManage.vue?vue&type=script&lang=js"
export * from "./commentManage.vue?vue&type=script&lang=js"
import style0 from "./commentManage.vue?vue&type=style&index=0&id=2e13b3c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e13b3c8",
  null
  
)

export default component.exports